import { render, staticRenderFns } from "./TipIcon.vue?vue&type=template&id=15fd3c8a&scoped=true"
import script from "./TipIcon.vue?vue&type=script&lang=js"
export * from "./TipIcon.vue?vue&type=script&lang=js"
import style0 from "./TipIcon.vue?vue&type=style&index=0&id=15fd3c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fd3c8a",
  null
  
)

export default component.exports